import { BindingEngine, autoinject, bindable, bindingMode, customElement, observable, factory } from 'aurelia-framework';

import { BaseCustomElement } from 'Common/BaseCustomElement';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { activationStrategy } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';

@autoinject
export class CheckBoxBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: boolean = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) valuetext: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) nullable: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) style: string = 'Switch';   // Switch (Ano/Ne)   /  Classic   /  Radio
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) initValue: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) classicColor: string = '#43a047';

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected i18n: I18N = null;
    protected isInit: boolean = false;

    protected yesLabel: string = 'YES';
    protected yesIcon: string = 'fas fa-check';
    protected yesColor: string = '#388e3c';

    protected noLabel: string = 'NO';
    protected noIcon: string = 'fas fa-times';
    protected noColor: string = '#d32f2f';

    constructor(element: Element, i18n: I18N) {
        super();
        this.element = element;
        this.i18n = i18n;
        this.yesLabel = this.i18n.tr('YES')
        this.noLabel = this.i18n.tr('NO')
        this.id = GuidHelper.NewGuid();
    }

    attached() {
        //console.log(999999, 'attached')
        if (ObjectHelper.ObjectIs(this.configJson) && ObjectHelper.ObjectIs(this.configJson.FieldConfig)) {
            if (StringHelper.StringIs(this.configJson.FieldConfig.BitType)) {
                this.style = this.configJson.FieldConfig.BitType;
            }
        }
        if (this.style == 'Radio') {
            if (ObjectHelper.ObjectIs(this.value) && (this.value === true || this.value === false)) {
                this.valuetext = this.value + '';
            }
        }
    }

    bind() {
        //console.log(999999, 'bind')
        if (ObjectHelper.ObjectIs(this.configJson) && ObjectHelper.ObjectIs(this.configJson.FieldConfig)) {
            if (ObjectHelper.ObjectIs(this.configJson.FieldConfig.BitYesConfig)) {
                switch (this.i18n.getLocale()) {
                    case "cs":
                    case "cs-CZ": {
                        this.yesLabel = this.configJson.FieldConfig.BitYesConfig.LabelCs;
                        break;
                    }
                    default: {
                        this.yesLabel = this.configJson.FieldConfig.BitYesConfig.LabelEn;
                        break;
                    }
                }
                this.yesIcon = this.configJson.FieldConfig.BitYesConfig.Icon;
                this.yesColor = this.configJson.FieldConfig.BitYesConfig.Color;
            }
            if (ObjectHelper.ObjectIs(this.configJson.FieldConfig.BitNoConfig)) {
                switch (this.i18n.getLocale()) {
                    case "cs":
                    case "cs-CZ": {
                        this.noLabel = this.configJson.FieldConfig.BitNoConfig.LabelCs;
                        break;
                    }
                    default: {
                        this.noLabel = this.configJson.FieldConfig.BitNoConfig.LabelEn;
                        break;
                    }
                }
                this.noIcon = this.configJson.FieldConfig.BitNoConfig.Icon;
                this.noColor = this.configJson.FieldConfig.BitNoConfig.Color;
            }
        }
        this.isInit = true;
        if (this.initValue && ObjectHelper.IsNullOrUndefined(this.value) && !this.nullable) {
            this.value = false;
        }
    }

    public SetAsTrue() {
        if (this.editable == null || this.editable == true) {
            this.value = true;
        }
    }

    public SetAsFalse() {
        if (this.editable == null || this.editable == true) {
            this.value = false;
        }
    }

    public SetAsTrueOrFalse() {
        if (this.editable == null || this.editable == true) {
            this.value = !this.value;
        }
    }

    async valuetextChanged(newValue, oldValue) {
        //console.log(9999999, 'valuetextChanged', oldValue, newValue)
        if (StringHelper.StringIs(newValue)) {
            this.value = newValue == 'true';
        }
    }

    async valueChanged(newValue, oldValue) {
        //if (ObjectHelper.IsNullOrUndefined(this.value)) {
        //    this.value = false;
        //}
        if (newValue != oldValue) {
            if (ObjectHelper.ObjectIs(this.onChange) && !this.forceChange && this.onChange != null) {
                await this.onChange();
            }
        }
    }
}